<template>
  <div class="candidate-number">
    <i class="las la-sitemap"></i>
    <span class="text under-selection">
      UNDER SELECTION :
      <span class="number">{{ job.candidateUnderSelectionCount }}</span>
    </span>
    <span class="text on-going">
      ON GOING:
      <span class="number">{{ job.candidateOnGoingCount }}</span></span
    >
  </div>
</template>

<script>
import Vue from 'vue'
import PortalVue from 'portal-vue'
Vue.use(PortalVue)

export default {
  name: 'CandidateProcessNumber',

  props: {
    job: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
@import 'stylesheets/global';
.candidate-number {
  color: $black;
  font-size: 1em;

  @include sp {
    font-size: 10px;
    min-width: 220px;
  }

  i {
    color: #3742fa;
    font-size: 20px;
    margin-right: 6px;
    margin-top: 3px;

    @include sp {
      font-size: 16px;
    }
  }

  .text {
    font-weight: 500;
    margin-right: 10px;

    @include sp {
      margin-right: 5px;
    }

    &.under-selection {
      .number {
        color: #f76400;
        font-weight: bolder;
      }
    }
    &.on-going {
      .number {
        color: #3742fa;
        font-weight: bolder;
      }
    }
  }
}
</style>
